<rask-page pageTitle="{{'ABOUT_HEADER' | translate}}">
  <rask-container-block>
    <ng-container header>{{'ABOUT_TROUBLESHOOTING' | translate}}</ng-container>
    <ul>
      @if (about.releaseInfoBuildNumber) {
        <li>{{'ABOUT_BUILDNUMBER' | translate}}:
        {{about.releaseInfoBuildNumber}}</li>
      }
      @if (about.releaseInfoReleaseId) {
        <li>{{'ABOUT_RELEASEID' | translate}}: {{about.releaseInfoReleaseId}}
        </li>
      }
      @if (about.releaseInfoPublishDate) {
        <li>{{'ABOUT_PUBLISHDATE' | translate}}:
        {{about.releaseInfoPublishDate | date: 'medium'}}</li>
      }
      @if (about.userName) {
        <li>Inloggad som:
        {{about.userName}} ({{about.azureUserId}})</li>
      }
      @if (about.roles) {
        <li>
          <p>{{'ABOUT_ROLES' | translate}}:</p>
          <ul>
            @for (role of about.roles; track role) {
              <li>{{ role }}</li>
            }
          </ul>
        </li>
      }
    </ul>
  </rask-container-block>

  <rask-header>
    Nedan listas alla ingående tredjepartskomponenter för klienten med tillhörande licensvillkor.
  </rask-header>

    @if (licenses | async; as licenseList) {
        @for (license of licenseList; track license) {
        <rask-container-block [noBorder]="true">
            <pre>{{ license }}</pre>
        </rask-container-block>
        }
    }
</rask-page>